import { Box, Grid, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { ButtonV1, DatePickerV1 } from "components";

/**
 * @description ColumnView component for displaying filter sections
 * @param {Object} props - Component props
 * @param {string} props.title - Title of the filter section
 * @param {React.ReactNode} props.children - Content of the filter section
 * @returns {JSX.Element} The rendered component
 */
const ColumnViewWithController = ({ title, name, control }) => {
  return (
    <Grid item xs={2}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box>
          <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange } }) => (
              <TextField
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                placeholder={title}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
      </Box>
    </Grid>
  );
};

/**
 * @description Main Filter component for managing filter sections
 * @param {Object} props - Component props
 * @param {Function} props.onSubmit - Callback function to handle form submission
 * @returns {JSX.Element} The rendered component
 */
const Filter = ({ onSubmit, onReset }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      skuName: "",
      plantCode: "",
      soNumber: "",
      soLineItemNumber: "",
      orderId: "",
      uploadDate: null,
    },
  });

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  const handleReset = () => {
    reset();
    onSubmit(null);
    onReset();
  };
  return (
    <Box>
      <Box as="form" onSubmit={handleSubmit(handleFormSubmit)} mb={4}>
        <Grid container spacing={2}>
          <ColumnViewWithController
            title="ERP SKU name"
            name="skuName"
            control={control}
          />
          <ColumnViewWithController
            title="Plant code"
            name="plantCode"
            control={control}
          />
          <ColumnViewWithController
            title="SO number"
            name="soNumber"
            control={control}
          />
          <ColumnViewWithController
            title="SO line item number"
            name="soLineItemNumber"
            control={control}
          />
          <ColumnViewWithController
            title="Order ID"
            name="orderId"
            control={control}
          />
          <Grid item xs={2}>
            <Controller
              control={control}
              name={"uploadDate"}
              render={({ field: { value, onChange } }) => (
                <DatePickerV1
                  value={value}
                  onChange={onChange}
                  inputProps={{
                    placeholder: "Upload date",
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Box display={"flex"} gap={2} mt={2}>
          <ButtonV1 type="submit" title={"Submit"} disabled={!isDirty} />
          <ButtonV1
            variant="outlined"
            title={"Reset"}
            onClick={handleReset}
            disabled={!isDirty}
          />
        </Box>
      </Box>
    </Box>
  );
};

Filter.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
};

export default Filter;
